module.exports = __webpack_public_path__ + "static/media/demo-3.689b6bf1.jpg";